import { Link } from 'gatsby'
import PropTypes from 'prop-types'
import React from 'react'
import theme from 'styles/theme'

import { pageURL } from '../lib/build/pagination'
import hexToRgb from '../lib/hexToRgb'

const borderColor = hexToRgb(theme.colors.broccoliLight, 0.5)

const Pagination = ({ pageCount, ...rest }) => {
  if (pageCount <= 1) {
    return null
  }

  return (
    <div
      className='Pagination'
      css={{
        margin: '5rem 0',
        textAlign: 'center',
      }}
    >
      {[...Array(pageCount)].map((_, i) => (
        <PageLink key={i} linkPage={i + 1} {...rest} />
      ))}
    </div>
  )
}

Pagination.propTypes = {
  pageCount: PropTypes.number.isRequired,
}

const PageLink = ({ basePath, currentPageNumber, linkPage }) => {
  const active = currentPageNumber === linkPage

  return (
    <Link
      to={pageURL({ basePath, page: linkPage })}
      css={{
        ...theme.h4,
        textDecoration: 'none',
        color: theme.colors.spinachDark,
        backgroundColor: active ? theme.colors.broccoliLight : theme.colors.w100,
        display: 'inline-block',
        width: '5rem',
        height: '5rem',
        lineHeight: '5rem',
        textAlign: 'center',
        borderRadius: '999px',
        margin: '.5rem',
        boxShadow: '0 0 0 0' + borderColor,
        transition: '150ms linear all',
        ':hover': {
          boxShadow: '0 0 0 .5rem ' + borderColor,
        },
      }}
    >
      {linkPage}
    </Link>
  )
}

PageLink.propTypes = {
  basePath: PropTypes.string.isRequired,
  currentPageNumber: PropTypes.number.isRequired,
  linkPage: PropTypes.number.isRequired,
}

export default Pagination
